import Service from "../Service";

import Vue from "vue";

export default {

    getUrlSearchConceptServiceAccount() {
        return Vue.prototype.$http.defaults.baseURL + "GenConceptServiceAccount/list";
    },
};